import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right--sprite",
  "use": "arrow-right--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"arrow-right--sprite\">\n    <defs>\n        <path id=\"arrow-right--sprite_a\" d=\"M1.053 19L0 18.113l8.07-8.524L0 1.065 1.053 0 10 9.59z\" />\n    </defs>\n    <use fill-rule=\"evenodd\" transform=\"translate(11 7)\" xlink:href=\"#arrow-right--sprite_a\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol